import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import useCheckDepositDetails from 'features/rdc/hooks/useCheckDepositDetails';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import SectionedContentScreen from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import DefaultPageDownErrorMessage from 'shared/patterns/vxl/errors/PageDownErrorMessage/DefaultPageDownErrorMessage';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

export default function CheckDepositDetails() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();
  const { response, error, loading, refetch } = useCheckDepositDetails({
    id,
  });
  const { bottom } = useSafeAreaInsets();

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
          title: response?.title,
        }}
      />
      {response?.sectionList ? (
        <SectionedContentScreen
          contentContainerStyle={{ paddingBottom: bottom }}
          model={response.sectionList}
          initialNumToRender={25}
          maskCellsFromAmplitude={true}
          maskHeaderFromAmplitude={true}
        />
      ) : null}
      <ScreenTransitionOverlay
        isLoading={loading}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={
          error ? (
            <DefaultPageDownErrorMessage
              error={error}
              title={defaultTitle}
              message={defaultMessage}
              tryAgainAction={refetch}
            />
          ) : null
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    zIndex: 1,
  },
});
